import { DynamicAttributeEntity } from "gql/graphql";
import { useTranslations } from "use-intl";

export function DynamicAttributeEntityTitle({
  entity,
}: {
  entity: DynamicAttributeEntity;
}) {
  const t = useTranslations("DynamicAttributeEntityTitle");

  return <span>{t(entity)}</span>;
}
